module.exports = __webpack_public_path__ + "static/media/flow-logo.7d05ec26.svg";